module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-pa001.a63091f7.png";